// @flow
import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Input from "elevate-ui/Input";
import Textarea from "elevate-ui/Textarea";
import Button from "elevate-ui/Button";
import Typography from "elevate-ui/Typography";
import Captcha from "../common/Captcha";
import { withGlobalContext } from "../common/GlobalContext";
import PhoneInput from "../common/PhoneInput";

type $Props = {
  classes: Object,
  className: string,
  previousFormFieldValues: Object,
  siteUser: Object,
  assertCaptcha: Function,
  assertCaptchaV2: Function,
  isPageForceV2Captcha: Function,
};

type $State = {
  token: string,
};

class ContactForm extends Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);
    this.state = {
      token: "",
    };
  }

  componentDidMount = () => {
    const { assertCaptchaV2, isPageForceV2Captcha } = this.props;
    if (isPageForceV2Captcha()) {
      assertCaptchaV2();
    }
  };

  onSubmit = () => {
    const { assertCaptcha, isPageForceV2Captcha } = this.props;
    if (isPageForceV2Captcha()) {
      // $FlowIgnore
      document.getElementById("contact-form").submit();
    } else {
      assertCaptcha("contact").then((token) => {
        this.setState({ token }, () => {
          // $FlowIgnore
          document.getElementById("contact-form").submit();
        });
      });
    }
  };
  render() {
    const {
      classes,
      className,
      previousFormFieldValues,
      siteUser,
      isPageForceV2Captcha,
    } = this.props;
    return (
      <div className={classNames(classes.root, className)}>
        <Typography type="heading3" className={classes.heading}>
          Contact Us
        </Typography>
        <Typography type="body" className={classes.subHeading}>
          We'll get back to you as soon as possible!
        </Typography>
        <Formik
          initialValues={{
            firstName:
              (previousFormFieldValues && previousFormFieldValues.firstName) ||
              (siteUser && siteUser.firstName) ||
              "",
            lastName:
              (previousFormFieldValues && previousFormFieldValues.lastName) ||
              (siteUser && siteUser.lastName) ||
              "",
            email:
              (previousFormFieldValues && previousFormFieldValues.email) ||
              (siteUser && siteUser.email) ||
              "",
            body:
              (previousFormFieldValues && previousFormFieldValues.body) || "",
            phone:
              (previousFormFieldValues && previousFormFieldValues.phone) ||
              (siteUser && siteUser.phone) ||
              "",
          }}
          validationSchema={() =>
            Yup.object().shape({
              firstName: Yup.string().required("First name is required"),
              lastName: Yup.string().required("Last name is required"),
              email: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
              body: Yup.string().required("A comment or question is required"),
              phone: Yup.string().matches(
                /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
                "Please enter valid phone number"
              ),
            })
          }
          onSubmit={this.onSubmit}
          render={({ isSubmitting }) => (
            <Form method="POST" id="contact-form" noValidate>
              <div className={classes.row}>
                <Field
                  id="firstName"
                  name="firstName"
                  label="First Name"
                  component={Input}
                />
                <Field
                  id="lastName"
                  name="lastName"
                  label="Last Name"
                  component={Input}
                />
              </div>
              <div className={classes.row}>
                <Field
                  id="email"
                  name="email"
                  label="Email"
                  component={Input}
                />
              </div>
              <div className={classes.row}>
                <Field
                  id="phone"
                  name="phone"
                  label="Phone"
                  component={PhoneInput}
                />
              </div>
              <div className={classes.row}>
                <Field
                  id="body"
                  name="body"
                  label="Comments / Questions"
                  component={Textarea}
                />
              </div>
              <Captcha
                token={this.state.token}
                isPageForceV2Captcha={isPageForceV2Captcha()}
              />
              <Button
                type="submit"
                className={classNames(classes.contactBtn)}
                disabled={isSubmitting}
              >
                <span className={classes.contactText}>Send Message</span>
              </Button>
            </Form>
          )}
        />
      </div>
    );
  }
}

export default withStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: "#fff !important",
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "400px",
    padding: "0px 12px",
    margin: "96px auto",
  },
  heading: {
    textAlign: "center",
  },
  subHeading: {
    textAlign: "center",
    margin: "auto",
    marginBottom: theme.spacing.unit * 3,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",

    "& > * + *": {
      marginLeft: theme.spacing.unit * 0.75,
    },
  },
  contactBtn: {
    width: "100%",
    height: "54px",
    margin: "16px 0",
    fontSize: "24px",
    fontWeight: "600",
  },
  contactText: {
    fontSize: "20px",
  },
}))(withGlobalContext(ContactForm));
